interface FnReturnType {
  top: number;
  left: number;
}

export const elementPositionToViewPort = <T extends HTMLElement>(
  el: T | null
): FnReturnType | null => {
  if (el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft =
      window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    const distanceTop = scrollTop + vh - rect.top;
    const percentageTop = Math.round(distanceTop / ((vh + rect.height) / 100));

    const distanceLeft = scrollLeft + vw - rect.left;
    const percentageLeft = Math.round(distanceLeft / ((vw + rect.width) / 100));

    return {
      top: percentageTop,
      left: percentageLeft,
    };
  }
  return null;
};
